import { createSelector } from "@reduxjs/toolkit";

import { selectEmailsFromProjectInvitations } from "./invitation/invitation.selectors";
import { selectEmailsFromProjectAccesses } from "./projectAccess/projectAccess.selectors";

export const selectEmailsWithProjectAccessOrInvitationSent = createSelector(
  selectEmailsFromProjectInvitations,
  selectEmailsFromProjectAccesses,
  (projectAccessesEmails, invitationsEmails) => [
    ...invitationsEmails,
    ...projectAccessesEmails
  ]
);
